/**
 * A company's «Tipo de transporte» (#220, Addendum No. 4, Point 12; the approved plan,
 * `docs/deca-transport-type-and-address-book-plan.md`, §1.2).
 *
 * It decides what the portal **offers** a company: the list's «Todos / Mercancías / Viajeros» tabs,
 * the type switch on «Crear DeCA», «Duplicar», and the templates on «Importar». A company's documents
 * of the other type stay listed and open as before, and the API refuses neither type. Like
 * `roles.ts`, this is a UI affordance, not an authorisation boundary.
 */

import type { CurrentPrincipal } from '@deca/api'

/** Which of the two document families the portal offers. */
export interface OfferedFamilies {
  goods: boolean
  passenger: boolean
}

/**
 * The families offered to [principal]'s company. ASGTRANS's own roles are offered both, with or
 * without a company chosen (plan §1.2). A server before #220 sends no type, which means both, as
 * every company had before; so does no principal.
 */
export function offeredFamilies(principal: CurrentPrincipal | null | undefined): OfferedFamilies {
  const organisation = principal?.organisation
  if (!organisation || organisation.isPlatform) return { goods: true, passenger: true }
  const type = organisation.transportType ?? 'BOTH'
  return { goods: type !== 'PASSENGER', passenger: type !== 'GOODS' }
}
